import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LangOptions } from 'highcharts';

@Injectable({
  providedIn: 'root',
})
export class HighChartsI18n {
  constructor(private readonly translate: TranslateService) {
  }

  get langOptions(): LangOptions {
    return {
      noData: this.translate.instant('NoData'),
      printChart: this.translate.instant('PrintChart'),
      downloadPNG: this.translate.instant('DownloadPNG'),
      downloadJPEG: this.translate.instant('DownloadJPEG'),
      downloadSVG: this.translate.instant('DownloadSVG'),
      downloadCSV: this.translate.instant('DownloadCSV'),
      downloadXLS: this.translate.instant('DownloadXLS'),
      weekdays: this.translate.instant('Calendar.weekDays'),
      months: this.translate.instant('Calendar.months'),
      shortMonths: this.translate.instant('Calendar.months.short'),
      shortWeekdays: this.translate.instant('Calendar.weekDays.short'),
    };
  }
}
